import Blue from '~/core';

// color setup
new Blue({
	name: 'Market Image Overlay',
	selector: '.market-image-overlay',
	setup(root) {
		setImageSrc();
		setupClickHandlerToOpenOverlay();
		setupClickHandlerToCloseOverlay();

		function setupClickHandlerToOpenOverlay() {
			const targetElements = [...document.querySelectorAll('.market-faq-section__image, .market-faq-section__expand')] || [];

			targetElements.forEach(element => {
				element.addEventListener('click', e => {
					e.preventDefault();
					root.classList.add('is-open');
				});
			});
		}

		function setImageSrc() {
			const imageSrc = root.dataset.imageSrc;
			const imageElement = root.querySelector('img');

			imageElement.src = imageSrc;
		}

		function setupClickHandlerToCloseOverlay() {
			root.addEventListener('click', e => {
				const isActive = e.target.classList.contains('is-open');
				const didClickBackground = e.target === root;

				if (didClickBackground && isActive) root.classList.remove('is-open');
			});
		}
	},
});
